export const environment = {
  production: true,
  firebase:{
    apiKey: "AIzaSyBW8qfF7YiNO8RaQFZUqk2UMfbGBzyVIdE",
    authDomain: "medical-a7f5d.firebaseapp.com",
    databaseURL: "https://medical-a7f5d.firebaseio.com",
    projectId: "medical-a7f5d",
    storageBucket: "medical-a7f5d.appspot.com",
    messagingSenderId: "70221312212",
    appId: "1:70221312212:web:b16baa103dab4ee21ecb41",
    measurementId: "G-1ZZCSWLMGL"
    // apiKey: "AIzaSyCWT6Kos5SI0v520kO032pOFJaKIZtCWVM",
    // authDomain: "medicalbeta-6a606.firebaseapp.com",
    // projectId: "medicalbeta-6a606",
    // storageBucket: "medicalbeta-6a606.firebasestorage.app",
    // messagingSenderId: "724351693711",
    // appId: "1:724351693711:web:9abf5a76e15ccecb3f91fa",
    // measurementId: "G-VVVK7WBHF8"
  }
};
